import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navigation = () => {
  // The mobile menu is opened and closed here rather than by Bootstrap's
  // collapse plugin, so it can close again after a link is tapped.
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle${menuOpen ? "" : " collapsed"}`}
            aria-expanded={menuOpen}
            aria-controls="main-navbar"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link to="/" onClick={closeMenu}>
            <img
              src="/img/logo/essilogo.webp"
              className="navbar-brand"
              alt="ESSI Security & Defence"
              style={{ height: '50px', width: '150px', padding: '0px', margin: '0px'}}
            />
          </Link>
        </div>
        <div
          className={`collapse navbar-collapse${menuOpen ? " in" : ""}`}
          id="main-navbar"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <Link to="/" className="page-scroll" onClick={closeMenu}>
                Home
              </Link>
            </li>

            <li>
              <Link to="/products" className="page-scroll" onClick={closeMenu}>
                Products
              </Link>
            </li>
            <li>
              <Link to="/services" className="page-scroll" onClick={closeMenu}>
                Services
              </Link>
            </li>

            <li>
              <Link to="/clients" className="page-scroll" onClick={closeMenu}>
                Clients
              </Link>
            </li>
            <li>
              <Link to="/contact" className="page-scroll" onClick={closeMenu}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
